type Translations = {
  [key: string]: {
    eng: string;
    lv: string;
    ru: string;
  };
};

const translations: Translations = {
  header_home: {
    eng: "HOME",
    lv: "SĀKUMS",
    ru: "ГЛАВНАЯ"
  },
  header_collection: {
    eng: "ALL PAINTINGS",
    lv: "VISAS GLEZNAS",
    ru: "ВСЕ КАРТИНЫ"
  },
  header_about_me: {
    eng: "ABOUT ME",
    lv: "PAR MANI",
    ru: "ОБО МНЕ"
  },
  header_cart: {
    eng: "CART",
    lv: "GROZS",
    ru: "КОРЗИНА"
  },
  hero_title: {
    eng: "Original Paintings That Tell a Story",
    lv: "Oriģinālas gleznas, kas izklāsta stāstu",
    ru: "Оригинальные картины, рассказывающие историю"
  },
  hero_button: {
    eng: "SHOW MORE",
    lv: "SKATĪTIES VAIRĀK",
    ru: "ПОКАЗАТЬ БОЛЬШЕ"
  },
  product_title: {
    eng : "MY ARTWORK",
    lv: "MANAS GLEZNAS",
    ru: "МОИ КАРТИНЫ"
  },
  product_view_more_button: {
    eng: "VIEW ALL PAINTINGS",
    lv: "APSKATĪT VISAS GLEZNAS",
    ru: "СМОТРЕТЬ ВСЕ КАРТИНЫ"
  },

  product_view_more_title: {
    eng: "VIEW ALL MY PAINTINGS BELLOW",
    lv: "APSKATI VISAS MANAS GLEZNAS ZEMĀK",
    ru: "ПОСМОТРЕТЬ ВСЕ МОИ КАРТИНЫ НИЖЕ"
  },

  product_empty_error: {
    eng: "No paintings available at the moment. Check back soon!",
    lv: "Šobrīd neviena glezna nav pieejama. Drīzumā pārbaudiet vēlreiz!",
    ru: "На данный момент картин нет. Заходите позже!"
  },
  about_me_journey: {
    eng: "My artistic journey began in Latvia, where I found inspiration in nature, urban landscapes, and cultural heritage, expressing emotions through art long before I had the words to describe them. ",
    lv: "Mans mākslinieciskais ceļojums sākās Latvijā, kur es atradu iedvesmu dabā, pilsētas ainavās un kultūras mantojumā, izpaužot emocijas mākslā ilgi pirms tam, kad spēju tās aprakstīt vārdos. ",
    ru: "Мой художественный путь начался в Латвии, где я черпал вдохновение в природе, городских пейзажах и культурном наследии, выражая эмоции через искусство задолго до того, как мог описать их словами. "
  },
  about_me_myself: {
    eng: "Initially self-taught, I later refined my technique at the Academy of Riga, developing a signature style that blends abstract fluidity, impressionistic light, and bold realism.",
    lv: "Sākotnēji pašmācībā, vēlāk es pilnveidoju savu tehniku Rīgas Akadēmijā, attīstot unikālu stilu, kas apvieno abstraktu plūdumu, impresionistisku gaismu un drosmīgu reālismu.",
    ru: "Сначала я обучался самостоятельно, а затем совершенствовал свою технику в Академии Риги, развивая уникальный стиль, сочетающий абстрактную текучесть, импрессионистский свет и смелый реализм."
  },
  all_paintings: {
    eng: "All paintings",
    lv: "Visas gleznas",
    ru: "Все картины"
  },

  cart_name: {
    eng: "Shopping cart",
    lv: "Iepirkumu grozs",
    ru: "Корзина"
  },
  cart_empty: {
    eng: "No items in cart",
    lv: "Grozā nav preču",
    ru: "В корзине нет товаров"
  },
  continue_shopping: {
    eng: "Continue shopping",
    lv: "Turpināt iepirkties",
    ru: "Продолжить покупки"
  },
  cart_remove: {
    eng: "Remove",
    lv: "Noņemt",
    ru: "Удалить"
  },
  cart_remove_confirm: {
    eng: "Are you sure?",
    lv: "Vai esat pārliecināts?",
    ru: "Вы уверены?"
  },
  cart_yes: {
    eng: "Yes",
    lv: "Jā",
    ru: "Да"
  },
  cart_no: {
    eng: "No",
    lv: "Nē",
    ru: "Нет"
  },
  cart_summary: {
    eng: "Summary",
    lv: "Kopsavilkums",
    ru: "Сводка"
  },
  cart_total: {
    eng: "Total",
    lv: "Kopā",
    ru: "Итого"
  },
  cart_checkout: {
    eng: "Checkout",
    lv: "Apmaksāt",
    ru: "Оформить заказ"
  },

  cart_total_items: {
    eng: "Item(s)",
    lv: "Prece(s)",
    ru: "Товар(ы)"
  },
  cart_total_price: {
    eng: "Total price",
    lv: "Kopējā cena",
    ru: "Общая стоимость"
  },

  cart_add_button: {
    eng: "Add to Cart",
    lv: "Pievienot grozam",
    ru: "Добавить в корзину"
  },
  cart_already_in_cart: {
    eng: "Already in Cart",
    lv: "Jau grozā",
    ru: "Уже в корзине"
  },
  cart_goto: {
    eng: "Go to Cart",
    lv: "Doties uz grozu",
    ru: "Перейти в корзину"
  },
  cart_added_message: {
    eng: "Painting has been added to your cart!",
    lv: "Glezna pievienota grozam!",
    ru: "Картина добавлена в корзину!"
  },
  product_description_title: {
    eng: "Description",
    lv: "Apraksts",
    ru: "Описание"
  },
  product_dimensions_title: {
    eng: "Size",
    lv: "Izmēri",
    ru: "Размеры"
  },
  product_price_title: {
    eng: "Price",
    lv: "Cena",
    ru: "Цена"
  },

  payment_success_message: {
    eng: "Payment Successful!",
    lv: "Maksājums ir veiksmīgs!",
    ru: "Платеж успешен!"
  },
  payment_success_text: {
    eng: "Thank you for your purchase! We will contact you shortly.",
    lv: "Paldies par pirkumu! Mēs ar jums sazināsimies tuvākajā laikā.",
    ru: "Спасибо за покупку! Мы свяжемся с вами в ближайшее время."
  },
  footer_made_by: {
    eng: "Made by",
    lv: "Izstrādāja",
    ru: "Сделано"
  },
  sold: {
    eng: "Sold",
    lv: "Pārdots",
    ru: "Продано"
  },
  cart_view: {
    eng: "View cart",
    lv: "Skatīt grozu",
    ru: "Смотреть корзину"
  }
}

export default translations